import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../components/vxc_select';

@customElement('vxw-menu')
export class TMenu extends LitElement {  
    private startDate: string = sessionStorage.getItem('period.startDate') || new Date().toISOString().split('T')[0];
    private endDate: string = sessionStorage.getItem('period.endDate') || new Date().toISOString().split('T')[0];

    @property({ type: String, attribute: 'name' }) name: string = ''
    @property({ type: String, attribute: 'logo' }) logo: string = ''
 
    render() {
      var formItems = [
        {
          "name": "startDate",
          "type": "date",
          "placeholder": "de",
          "width": "100",
          "before": "<svg fill=\"#000000\" viewBox=\"0 0 1920 1920\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <path d=\"M114.063 276v1368.756H0V276h114.063Zm739.106 73.765 80.642 80.642-473.02 473.02H1920v113.948H460.792l473.02 473.02-80.643 80.642-610.694-610.693 610.694-610.58Z\" fill-rule=\"evenodd\"></path> </g></svg>",
          "value": this.startDate,
          "required": true
        },
        {
          "name": "endDate",
          "type": "date",
          "placeholder": "A",
          "width": "100",
          "before": "<svg fill=\"#000000\" viewBox=\"0 0 1920 1920\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"> <path d=\"M1805.937 276v1368.756H1920V276h-114.063Zm-739.106 73.765-80.642 80.642 473.02 473.02H0v113.948h1459.208l-473.02 473.02 80.643 80.642 610.694-610.693-610.694-610.58Z\" fill-rule=\"evenodd\"></path> </g></svg>",
          "beforeIsSvg": true,
          "value": this.endDate,
          "required": true
        }
      ]
      var logoSVG = '<svg fill="#000000" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>magic</title> <path d="M9.5 9.625l-0.906 2.906-0.875-2.906-2.906-0.906 2.906-0.875 0.875-2.938 0.906 2.938 2.906 0.875zM14.563 8.031l-0.438 1.469-0.5-1.469-1.438-0.469 1.438-0.438 0.5-1.438 0.438 1.438 1.438 0.438zM0.281 24l17.906-17.375c0.125-0.156 0.313-0.25 0.531-0.25 0.281-0.031 0.563 0.063 0.781 0.281 0.094 0.063 0.219 0.188 0.406 0.344 0.344 0.313 0.719 0.688 1 1.063 0.125 0.188 0.188 0.344 0.188 0.5 0.031 0.313-0.063 0.594-0.25 0.781l-17.906 17.438c-0.156 0.156-0.344 0.219-0.563 0.25-0.281 0.031-0.563-0.063-0.781-0.281-0.094-0.094-0.219-0.188-0.406-0.375-0.344-0.281-0.719-0.656-0.969-1.063-0.125-0.188-0.188-0.375-0.219-0.531-0.031-0.313 0.063-0.563 0.281-0.781zM14.656 11.375l1.313 1.344 4.156-4.031-1.313-1.375zM5.938 13.156l-0.406 1.438-0.438-1.438-1.438-0.469 1.438-0.438 0.438-1.469 0.406 1.469 1.5 0.438zM20.5 12.063l0.469 1.469 1.438 0.438-1.438 0.469-0.469 1.438-0.469-1.438-1.438-0.469 1.438-0.438z"></path> </g></svg>' 
      var botItems = [
        { label: 'ChatBot', value: 'f5d9466c-14e5-4cf4-aa6b-db7f56fab9de' },
        { label: 'CallBot', value: '42365e25-9370-4834-8315-cc65b6df1336' }
      ]
      return html`
        <vxc-drawer
            brand="${this.name}"
            logo='${logoSVG}'
          >
            <div>
              <vxc-form 
                action="session:period"
                submit-btn-text="Afficher"
                form-items='${JSON.stringify(formItems)}'>
                </vxc-form>
              </vxc-drawer>
              
              <div  style="margin: 2rem 1rem">
                <vxc-select
                  name="agent"
                  storage="session"
                  value="Chat_bot"
                  label="Selection de BOT"
                  placeholder="Selectionnez un Bot"
                  items=${JSON.stringify(botItems)}
                >
                </vxc-select>
              </div>
            </div>
      `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxw-menu': TMenu;
  }
}